<template>
  <div>
    <div
      :class="[gameType === 'MW' ? 'modal modal-game_memory_wizard' : gameType === 'ODD' ? 'modal modal-game_odd_object': 'modal modal-game_spot_difference']"
      :id="[gameType === 'MW' ? 'modal-game_memory_wizard' : gameType === 'ODD' ? 'modal-game_odd_object': 'modal-game_spot_difference']">
      <div class="modal__content won_game_modal">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
          <div class="row gamepage_header">
            <img v-if="gameType === 'MW'" class="gamepage_logo " src="static/images/logo-memory-wizard.png"/>
            <img v-if="gameType === 'ODD'" class="gamepage_logo " src="static/images/logo-odd-object.png"/>
            <img v-if="gameType === 'SD'" class="gamepage_logo " src="static/images/logo-spot-difference.png"/>
            <h1 v-if="gameType === 'MW'">{{ getTranslations.home_game_memory_wizard }}</h1>
            <h1 v-if="gameType === 'ODD'">{{ getTranslations.home_game_odd_game }}</h1>
            <h1 v-if="gameType === 'SD'">{{ getTranslations.home_game_sd_game }}</h1>
            <p>{{ getTranslations.home_modals_mw_post_you_won }}</p>

            <p v-if="gameType === 'ODD'">{{ getTranslations.home_modals_odd_post_you_are }}</p>
            <p v-if="gameType === 'ODD'" class="cta_support">{{ getTranslations.home_modals_mw_post_choose_one
              }}</p>

            <p v-if="gameType === 'MW'">{{ getTranslations.home_modals_mw_post_you_are }}</p>
            <p v-if="gameType === 'MW'" class="cta_support">{{ getTranslations.home_modals_mw_post_choose_one }}</p>

            <p v-if="gameType === 'SD'">{{ getTranslations.home_modals_sd_post_you_are }}</p>
            <p v-if="gameType === 'SD'" class="cta_support">{{ getTranslations.home_modals_mw_post_choose_one }}</p>
          </div>
        </div>
        <div class="modal__body">
          <div class="row gamepage_game">

            <div class="col-6 gamepage_game_image hide_card" v-for="(prize, index) in personalizedData"
                 @click="sendAnswer((index + 1))"
                 :style="disableDiv"
                 :key="index+1" :ref="index+1">
              <div :id="`prizeId${(index+1)}`" class="game_image_data" :style="showStyleBackground(prize.imageURL)"></div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState, mapMutations } from 'vuex';
import PostGamePrizeVisitor from '@/components/visitor/freeGameProcess/PostGamePrizeVisitor';
import { GameMixin, GameMixin4 } from '@/common/mixins/game';
import NewGameMixin from '@/common/mixins/home';
import modals from '../../../common/modals';

export default {
  name: 'post-game-visitor',
  mixins: [NewGameMixin, GameMixin, GameMixin4],
  data() {
    return {
      showedModal: false,
      nonWonIndexes: [],
      personalizedData: [
        {
          id: 1,
          imageURL: 'static/images/modals/icon-postgame-prize-cover-gift.png',
        },
        {
          id: 2,
          imageURL: 'static/images/modals/icon-postgame-prize-cover-gift.png',
        },
        {
          id: 3,
          imageURL: 'static/images/modals/icon-postgame-prize-cover-gift.png',
        },
        {
          id: 4,
          imageURL: 'static/images/modals/icon-postgame-prize-cover-gift.png',
        },
      ],
    };
  },
  created() {
    console.log('in PostGame created hook');
    this.initQuestionData();
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'validTransitionForFreeGameMethod',
      'resetUnauthorizedMsisdn',
      'resetCode',
    ]),
    ...mapMutations('game', [
      'resetGameState',
      'resetPrizeData',
      'isGamePageFlow',
      'updateGameType',
    ]),
    initQuestionData() {
      console.log('initializing post Game data...');
      console.log('this.personalizedData:', this.personalizedData);
      this.normalTransition = false;
    },
    sendAnswer(index) {
      console.log('--> inside sendAnswer....');
      console.log('Card Index:', index);
      return this.$axios({
        url: `api/redeemPrizeForFreeGame?gameType=${this.gameType}&gameId=${this.gameID}&isGamePage=${this.isGamePage}&msisdn=${this.unauthorizedMsisdn}`,
        method: 'GET',
      }).then((response) => {
        console.log('response from core for Prizes');
        console.log(response);
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          this.setPrizePostGameData(response.data.data);
          this.nonWonIndexes = [1, 2, 3, 4].filter(nonWonIndex => nonWonIndex !== index);
          // extend impl to Notification Page
          // eslint-disable-next-line
          $('#prizeId' + index).attr('style', this.showStyleBackground(this.playersDetails.winDTO.imageUrl));
          // change url of the other prizes
          // eslint-disable-next-line
          this.nonWonIndexes.forEach(element => $('#prizeId' + element).attr('style', this.showStyleBackground(this.playersDetails.lostDTOs[this.nonWonIndexes.indexOf(element)].imageUrl)));
          this.successAnimationForIndexes(index);
        }
      });
    },
    successAnimationForIndexes(lastChoice) {
      this.$refs[1][0].classList.add('show_card');
      this.$refs[2][0].classList.add('show_card');
      this.$refs[3][0].classList.add('show_card');
      this.$refs[4][0].classList.add('show_card');
      setTimeout(() => {
        this.$refs[lastChoice][0].classList.add('success_card');
      }, 1000);
      setTimeout(() => {
        this.$refs[lastChoice][0].classList.add('success_animation');
      }, 2000);
      setTimeout(() => {
        this.$refs[lastChoice][0].classList.remove('success_animation');
        this.storeModalForHomePage(PostGamePrizeVisitor);
        modals.showHideModalForFreeGame(this);
      }, 3000);
    },
    showStyleBackground(url) {
      // eslint-disable-next-line
      return 'background-image:url(' + url.toString() + ')';
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'playersDetails',
      'gameID',
      'gameType',
      'isGamePage',
    ]),
    ...mapState('common', [
      'unauthorizedMsisdn',
    ]),
    disableDiv() {
      return (this.nonWonIndexes.length === 0) ? 'cursor:pointer' : 'pointer-events:none';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeGameProcess/PostGameVisitor.vue